import { cellText, comparisonScope, identifyEntries, type ComparisonColumn, type ComparisonEntry, type ComparisonLang } from './comparison-data'
import styles from './comparison-table.module.css'

export default function ComparisonTable({ columns, rows, caption, lang }: {
  columns: ComparisonColumn[]; rows: ComparisonEntry[]; caption: string; lang: ComparisonLang
}) {
  const tr = lang === 'tr'
  return <div className={styles.comparison} id="comparison">
    <p id="comparison-scope" className={styles.scope}>
      {comparisonScope(lang)}
    </p>
    <table className={styles.table} role="table" aria-describedby="comparison-scope" data-columns={columns.length}>
      <caption>{caption}</caption>
      <thead role="rowgroup"><tr role="row">
        <th scope="col" role="columnheader" id="comparison-feature">{tr ? 'Özellik / kapsam' : 'Capability / scope'}</th>
        {columns.map((column, i) => <th key={column.name} scope="col" role="columnheader" id={`comparison-vendor-${i}`} data-highlight={column.highlight}>{column.name}</th>)}
      </tr></thead>
      <tbody role="rowgroup">{identifyEntries(rows).map(row => <tr key={row.id} id={row.id} role="row">
        <th id={`${row.id}-label`} scope="row" role="rowheader">
          <a href={`#${row.id}`} className={styles.featureLink}>{row.feature}<span aria-hidden="true">#</span></a>
          {row.detail && <p className={styles.detail}>{row.detail}</p>}
          {!!row.sources?.length && <ul className={styles.sources} aria-label={tr ? 'Bu özelliğin kaynakları' : 'Sources for this capability'}>{row.sources.map(source => <li key={source.href}><a href={source.href}>{source.label}<span aria-hidden> ↗</span></a></li>)}</ul>}
        </th>
        {columns.map((column, i) => <td key={column.name} role="cell" headers={`${row.id}-label comparison-vendor-${i}`} data-highlight={column.highlight}>
          <span className={styles.mobileLabel} aria-hidden="true">{column.name}</span>
          <span className={styles.value} data-status={typeof row.values[i] === 'boolean' ? String(row.values[i]) : row.values[i] === 'partial' ? 'partial' : undefined}>
            {typeof row.values[i] === 'boolean' && <span className={styles.statusIcon} aria-hidden="true">{row.values[i] ? '✓' : '−'}</span>}
            <span>{cellText(row.values[i], lang)}</span>
          </span>
        </td>)}
      </tr>)}</tbody>
    </table>
  </div>
}
